"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseError = void 0;
const error_types_1 = require("./error-types");
class BaseError extends Error {
    constructor(message) {
        super(message);
        this.errorType = error_types_1.ERROR_TYPES.default;
        this.data = {};
    }
}
exports.BaseError = BaseError;
//# sourceMappingURL=base-error.js.map